import { Link } from "react-router-dom";
import type { Character } from "@/mocks/characters";

export default function CharacterCard({ character }: { character: Character }) {
  return (
    <Link
      to={`/characters/${character.id}`}
      className="group flex flex-col rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-accent-300 transition-colors cursor-pointer"
    >
      <div className="relative w-full aspect-[4/5] overflow-hidden bg-background-200">
        <img
          src={character.image}
          alt={`${character.name} 角色形象`}
          title={`${character.name} - 希岛爱理角色解析`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-primary-950/85 to-transparent p-3 pt-8">
          <span className="text-xs text-background-200">《{character.workTitle}》</span>
        </div>
      </div>
      <div className="p-4">
        <h3 className="font-heading font-semibold text-base text-foreground-950 group-hover:text-accent-700 transition-colors">
          {character.name}
        </h3>
        <p className="text-sm text-foreground-600 mt-1.5 line-clamp-2 leading-relaxed">
          {character.description}
        </p>
      </div>
    </Link>
  );
}